<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <mask
      id="mask0_1202_737"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1202_737)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        :fill="color"
      />
      <path d="M25 -1H-1V25H25V-1Z" :fill="color" />
    </g>
    <path
      d="M13.3132 14.1118L13.8092 6.7998H10.8332L11.3292 14.1118H13.3132ZM12.3212 18.1278C12.7585 18.1278 13.1238 17.9865 13.4172 17.7038C13.7105 17.4211 13.8572 17.0771 13.8572 16.6718C13.8572 16.2665 13.7132 15.9278 13.4252 15.6558C13.1372 15.3838 12.7692 15.2478 12.3212 15.2478C11.8732 15.2478 11.5052 15.3838 11.2172 15.6558C10.9292 15.9278 10.7852 16.2665 10.7852 16.6718C10.7852 17.0771 10.9318 17.4211 11.2252 17.7038C11.5185 17.9865 11.8838 18.1278 12.3212 18.1278Z"
      fill="white"
    />
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'ExclamationSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
